import React, { useEffect, useState, version } from "react";
import "./EditActivationStep.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getSpecificActivationStep,
  editArticle,
} from "../../../../requests/articleAPI";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const EditActivationStep = ({ id }) => {
  const navigate = useNavigate();
  const userFormik = useFormik({
    initialValues: {
      title: "",
      category: "",
      tags: "",
      version: "",
      steps: [
        {
          stepName: "",
          subject: "",
        },
      ],
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please add Title"),
      category: Yup.string().required("Please add Category"),
      tags: Yup.string(),
      version: Yup.string(),
      steps: Yup.array().of(
        Yup.object().shape({
          stepName: Yup.string().required("Step name is required"),
          subject: Yup.string().required("Step Subject is required"),
        })
      ),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          title: values?.title,
          category: values?.category,
          tags: [values?.tags],
          status: values?.status,
          version: values?.version,
          steps: values?.steps,
        };
        const response = await editArticle(payload, id);
        if (response?.status == 200) {
          toast.success("Data Updated Successfully!");
        }
      } catch (error) {
        toast.error("Something Went Wrong!");
      } finally {
        navigate("/activation-steps");
        userFormik.resetForm();
      }
    },
  });
  const handleAddStep = () => {
    const steps = [...userFormik.values.steps];
    steps.push({ stepName: "", subject: "" });
    userFormik.setFieldValue("steps", steps);
  };

  const handleRemoveStep = (index) => {
    const steps = [...userFormik.values.steps];
    steps.splice(index, 1);
    userFormik.setFieldValue("steps", steps);
  };
  const getSpecifiStep = async () => {
    try {
      console.log("id", id);
      const response = await getSpecificActivationStep(id);
      console.log(response.data);

      if (response.data) {
        userFormik.setValues({
          title: response.data.title || "",
          category: response.data.category || "",
          tags: response.data.tags?.[0] || "",
          version: response.data.version || "",
          status: response.data.status || "",
          steps: response.data.steps?.length
            ? response.data.steps.map((s) => ({
                stepName: s.stepName || "",
                subject: s.subject || "",
              }))
            : [
                {
                  stepName: "",
                  subject: "",
                },
              ],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getSpecifiStep();
  }, [id]);
  return (
    <>
      <section className="edit-activation-page-section">
        <div className="search-input">
          <h5 className="form-title">Edit Activation Step</h5>
        </div>
        <form className="user-info" onSubmit={userFormik.handleSubmit}>
          <div className="user-inputs">
            <div className="row">
              <div className="col-md-6 mt-4">
                <div className="floating-label">
                  <input
                    type="text"
                    name="title"
                    placeholder="e.g. “Terms & Conditions”"
                    value={userFormik.values.title}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  />
                  <label className="floating-label-text">Title</label>
                  {userFormik.touched.title && userFormik.errors.title && (
                    <div className="error">{userFormik.errors.title}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6 mt-4">
                <div className="status">
                  <h4>Status</h4>
                  <div className="checkboxes">
                    {["Draft", "Published", "Archived"].map((statusOption) => (
                      <label key={statusOption} className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="status"
                          value={statusOption}
                          checked={userFormik.values.status === statusOption}
                          onChange={(e) => {
                            const { checked, value } = e.target;
                            userFormik.setFieldValue(
                              "status",
                              checked ? value : ""
                            );
                          }}
                        />
                        <span className="checkmark"></span>
                        <span className="name">{statusOption}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
      <section className="edit-activation-page-section mt-3">
        <div className="search-input">
          <h5 className="form-title">Steps</h5>
          <div
            className="add"
            onClick={handleAddStep}
            style={{ cursor: "pointer" }}
          >
            <p>
              <img src="/images/icons/color-circle.svg" alt="color-circle" />
              Add Steps
            </p>
          </div>
        </div>

        {userFormik.values.steps.map((step, index) => (
          <div key={index} className="step-wrapper mb-4">
            <div className="heading-wrapper">
              <h4>{`Step ${index + 1}`}</h4>
              <div
                className="remove"
                onClick={() => handleRemoveStep(index)}
                style={{ cursor: "pointer" }}
              >
                <p>
                  <img src="/images/icons/cross-circle.svg" alt="remove" />{" "}
                  Remove Step
                </p>
              </div>
            </div>

            <form action="" className="user-info">
              <div className="user-inputs">
                <div className="row">
                  <div className="col-md-6">
                    <div className="floating-label">
                      <input
                        type="text"
                        name={`steps[${index}].stepName`}
                        placeholder={`e.g. "Step ${index + 1}"`}
                        value={step.stepName}
                        onChange={userFormik.handleChange}
                        onBlur={userFormik.handleBlur}
                      />
                      <label className="floating-label-text">Step Name</label>
                      {userFormik.touched.steps &&
                        userFormik.touched.steps[index]?.stepName &&
                        userFormik.errors.steps &&
                        userFormik.errors.steps[index]?.stepName && (
                          <div className="error">
                            {userFormik.errors.steps[index].stepName}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="col-md-12 mt-4">
                    <div className="floating-label">
                      <textarea
                        name={`steps[${index}].subject`}
                        placeholder={`e.g. "Step ${index + 1} Description"`}
                        value={step.subject}
                        onChange={userFormik.handleChange}
                        onBlur={userFormik.handleBlur}
                      />
                      <label className="floating-label-text">
                        Step Description
                      </label>
                      {userFormik.touched.steps &&
                        userFormik.touched.steps[index]?.subject &&
                        userFormik.errors.steps &&
                        userFormik.errors.steps[index]?.subject && (
                          <div className="error">
                            {userFormik.errors.steps[index].subject}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        ))}

        <div className="btns">
          {/* <button
            className="custom-btn"
            data-bs-toggle="modal"
            data-bs-target="#cancelModal"
          >
            Delete Article
          </button> */}
          <button className="custom-btn" onClick={userFormik.handleSubmit}>
            Update Article
          </button>
        </div>
        <div
          className="modal fade"
          id="cancelModal"
          tabIndex="-1"
          aria-labelledby="cancelModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content markup-modal">
              <div className="modal-body">
                <h5 className="modal-title">Delete Article</h5>
                <p className="lh-base">
                  Are you sure you want to remove Article names{" "}
                  <strong style={{ color: "black" }}>’Privacy Policy’.</strong>{" "}
                  <br /> this Action will be irreversible!
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button type="button" className="btn">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditActivationStep;
